<nav class="navbar navbar-top navbar-expand-md navbar-dark" id="navbar-main">
  <div class="container-fluid">
    <!-- Brand -->
    <a class="h4 mb-0 text-white text-uppercase d-none d-lg-inline-block" routerLinkActive="active"
      [routerLink]="['/'+mainPath]">
      {{ getTitle() | transloco }}
    </a>

    <!-- User -->
    <ul class="navbar-nav align-items-center d-none d-md-flex">
      <li class="nav-item" appDropdown #customerDropdown="appDropdown" (click)="customerDropdown.isOpen = true" (mouseenter)="customerDropdown.isOpen = true"
        (mouseleave)="customerDropdown.isOpen = false">
        <a class="nav-link pr-0" role="button" appDropdownToggle>
          <div class="media align-items-center">
            <span class="avatar avatar-sm rounded-circle">
              @if (!sessionIsOpen) {
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" width="100%"
                  height="100%">
                  <circle cx="20" cy="20" r="20" fill="#5e72e4" />
                  <circle cx="20" cy="16" r="7" fill="#fff" />
                  <ellipse cx="20" cy="34" rx="12" ry="8" fill="#fff" />
                </svg>
              }
              @if (sessionIsOpen) {
                <img alt="Image placeholder" [src]="avatarUrl">
              }
            </span>
            @if (!sessionIsOpen) {
              <div class="media-body ml-2 d-none d-lg-block">
                <!-- SET NAME IN SESSION-->
                <span class="mb-0 text-sm  font-weight-bold">{{ 'label.login-invite' | transloco }}</span>
              </div>
            }
            @if (sessionIsOpen) {
              <div class="media-body ml-2 d-none d-lg-block">
                <!-- SET NAME IN SESSION-->
                <span class="mb-0 text-sm  font-weight-bold">{{ getCustomerName() }}</span>
              </div>
            }
          </div>
        </a>
        <div class="dropdown-menu-arrow dropdown-menu-right" appDropdownMenu>
          @if (sessionIsOpen && !isAppType) {
            <a routerLinkActive="active" [routerLink]="['/'+profilePath]" class="dropdown-item">
              <i class="sdx sdx-user"></i>
              <span>{{ 'label.profile' | transloco }}</span>
            </a>
          }
          <button class="dropdown-item" (click)="openLanguageModal()">
            <span class="avatar avatar-xs rounded-circle">
              <img alt="Image Lang" src="{{ langIcon }}">
            </span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;{{ 'language.title' | transloco }}</span>
          </button>
          <!--a routerLinkActive="active" [routerLink]="['/'+supportPath]" class="dropdown-item">
            <i class="sdx sdx-support"></i>
            <span>{{ 'label.support' | transloco }}</span>
          </a-->
          <div class="dropdown-divider"></div>
          @if (sessionIsOpen) {
            <button href="#!" class="dropdown-item" (click)="closeSession()">
              <i class="sdx sdx-door-closed"></i>
              <span>{{ 'label.close' | transloco }}</span>
            </button>
          }
          @if (!sessionIsOpen) {
            <a [routerLink]="['/'+loginPath]" class="dropdown-item">
              <i class="sdx sdx-door-open"></i>
              <span>{{ 'login.button' | transloco }}</span>
            </a>
          }
        </div>
      </li>
    </ul>
  </div>
</nav>
